
import React from "react";
import PropTypes from "prop-types"
import { Link } from "gatsby";
import styled from 'styled-components';
import { GatsbyImage} from "gatsby-plugin-image"


const StyledArticle = styled.article`
	
	float: left;
  
  > *{
    width: 100%;
  }
 
  .title {
  	font-family: var(--title-font);
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
   }
	
	.cat {
    font-size: 12px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.7);
    text-transform: capitalize;
    margin-bottom: 9px;
   }
	
	img{
  	width: 100%;
    height: auto;
  }
   
	.item_overlay{
  	position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: #6600cc;
    background: linear-gradient(to right, #6600cc, #6666ff);
    opacity: 0;
    visibility: hidden;
    padding: 40px;
    transition: all 0.3s ease;
 }
  
  &:hover .item_overlay {
    opacity: 1;
    visibility: visible;
	} 
`;
function postCard({node}) {
  
  return (
  	<StyledArticle>
      <Link  to={node.fields.slug}>
        {node.frontmatter.cover && (
    			<GatsbyImage 
    				image={node.frontmatter.cover.childImageSharp.gatsbyImageData} 
    				layout="constrained" 
    				alt={node.frontmatter.title}/>
    			
      	)}
      	
      	<div className="item_overlay">
					<div className="cat">{node.frontmatter.tags[0]}</div>
					<div className="title">{node.frontmatter.title}</div>
				</div>		
			
			</Link>
    </StyledArticle>
        
  );
}

postCard.propTypes = {
  node: PropTypes.object.isRequired,
};
export default postCard;
